export default __webpack_public_path__ + "static/media/R-logo.bf1bfc28.jpg";